import { enforce, create, test, only } from 'vest';

export default create((currentField, data = {},) => {

  only(currentField)
  test('descuento_comercial', 'El valor debe ser mayor o igual a 0 y menor o igual a 99', () => {
    enforce(data.descuento_comercial).isBetween(0, 99);
  })
  test('descuento_estrategico', 'El valor debe ser mayor o igual a 0 y menor o igual a 100', () => {
    enforce(data.descuento_estrategico).isBetween(0, 99);
  })
  test('empresa_id', 'Valor requerido', () => {
    enforce(data.empresa_id).isNotEmpty();
  })
  test('alicuota_id', 'Valor requerido', () => {
    enforce(data.alicuota_id).isNotEmpty();
  })
  test('tipo_venta_id', 'Valor requerido', () => {
    enforce(data.tipo_venta_id).isNotEmpty();
  })
  test('cantidad', 'Valor requerido', () => {
    enforce(data.cantidad).isNotEmpty();
  })
  test('cantidad', 'El valor debe ser mayor o igual a 1 y menor o igual a 100', () => {
    enforce(data.cantidad).isBetween(1, 100);
  })
  test('ubicacion_id', 'Valor requerido', () => {
    enforce(data.ubicacion_id).isNotEmpty();
  })
})
